import { render, staticRenderFns } from "./SettingsComponent.vue?vue&type=template&id=55a29187&"
import script from "./SettingsComponent.vue?vue&type=script&lang=js&"
export * from "./SettingsComponent.vue?vue&type=script&lang=js&"
import style0 from "./SettingsComponent.vue?vue&type=style&index=0&id=55a29187&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports